import { render } from "./PrivacyContainer.vue?vue&type=template&id=7abeaa6e"
import script from "./PrivacyContainer.vue?vue&type=script&lang=js"
export * from "./PrivacyContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__